document.addEventListener('DOMContentLoaded', () => {
	const swiper = document.querySelector('#about-slider');
	if(!swiper) return;
	if(!swiper.swiper) return;
	const {nextEl, prevEl} = swiper.swiper.navigation;
	const images = swiper.querySelectorAll('.image-area');

	const addAndRemoveClass = ($class, removeClass) => {
		images.forEach((el) => {
			el.classList.remove(`animation-slide-${$class}`);
			el.classList.remove(`animation-slide-${removeClass}`);
			if(el.closest('.swiper-slide-active')) {
				el.classList.add(`animation-slide-${$class}`);
			}
		})
	};

	nextEl.onclick = () => {
		addAndRemoveClass('next', 'prev')
	};

	prevEl.onclick = () => {
		addAndRemoveClass('prev', 'next')
	};
});
